export default __webpack_public_path__ + "static/media/desk.7cf3098e.png";